import { PropsWithChildren } from 'react';
import './form-container.less';

export default function FormContainer(props: PropsWithChildren<{}>) {
  return <div className="form-container">
    {props.children}
  </div>
}